module.exports = __webpack_public_path__ + "static/media/5DPO21.18a07e45.jpg";